// App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Agents from "./pages/Agents";
import Listings from "./pages/Listings";
import Transactions from "./pages/Transactions";
import Layout from "./Layout";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Layout currentPageName="Dashboard">
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/agents"
          element={
            <Layout currentPageName="Agents">
              <Agents />
            </Layout>
          }
        />
        <Route
          path="/listings"
          element={
            <Layout currentPageName="Listings">
              <Listings />
            </Layout>
          }
        />
        <Route
          path="/transactions"
          element={
            <Layout currentPageName="Transactions">
              <Transactions />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
